module.exports = __webpack_public_path__ + "img/install.21734533.svg";